import { render, staticRenderFns } from "./portfolio-grid-3-column.vue?vue&type=template&id=4c760300&"
import script from "./portfolio-grid-3-column.vue?vue&type=script&lang=js&"
export * from "./portfolio-grid-3-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports